import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModelInvoice } from 'src/app/entities/invoices';

@Component({
  selector: 'app-documenti-correlati',
  templateUrl: './documenti-correlati.component.html',
  styleUrls: ['./documenti-correlati.component.css']
})
export class DocumentiCorrelatiComponent implements OnInit, OnChanges {
  
  @Input() model : ModelInvoice | undefined;
  @Output() modelChange = new EventEmitter<ModelInvoice>();
  
  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1, 
        name: "invoices.edit.relatedDocuments.other.tabs.tab1"
      },
      {
        id: 2,
        name: "invoices.edit.relatedDocuments.other.tabs.tab2"
      },
      {
        id: 3,
        name: "invoices.edit.relatedDocuments.other.tabs.tab3"
      },
      {
        id: 4,
        name: "invoices.edit.relatedDocuments.other.tabs.tab4"
      },
      {
        id: 5,
        name: "invoices.edit.relatedDocuments.other.tabs.tab5"
      },
      {
        id: 6,
        name: "invoices.edit.relatedDocuments.other.tabs.tab6"
      },
      {
        id: 7,
        name: "invoices.edit.relatedDocuments.other.tabs.tab7"
      },
      {
        id: 8,
        name: "invoices.edit.relatedDocuments.other.tabs.tab8"
      }
    ]
  }

  constructor() { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.model){
      this.model = changes.model.currentValue;
    }
  }
  // Dati Ordine Acquisto
  public addDatiOrdineAcquisto(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto;
    //if(list?.filter(l => l.IdDocumento == "" || l.CodiceCIG == "" || l.CodiceCUP == "" || l.CodiceCommessaConvenzione == "" || l.Data == "" || l.NumItem == "").length == 0){
      list!.push({RiferimentoNumeroLinea: "", IdDocumento:"", Data: "", NumItem: "", CodiceCommessaConvenzione: "", CodiceCUP: "", CodiceCIG: ""});
      //list!.push({CodiceCIG: "", CodiceCUP: "",CodiceCommessaConvenzione: "",Data: "",IdDocumento:"",NumItem: "",RiferimentoNumeroLinea: ""});
    //}
  }
  public deleteDatiOrdineAcquisto(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto;
    list?.splice(index, 1);
  }

  // Dati Contratto
  public addDatiContratto(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiContratto;
    //if(list?.filter(l => l.IdDocumento == "" || l.CodiceCIG == "" || l.CodiceCUP == "" || l.CodiceCommessaConvenzione == "" || l.Data == "" || l.NumItem == "").length == 0){
      list!.push({RiferimentoNumeroLinea: "", IdDocumento:"", Data: "", NumItem: "", CodiceCommessaConvenzione: "", CodiceCUP: "", CodiceCIG: ""});
    //}
  }
  public deletedatiContratto(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiContratto;
    list?.splice(index, 1);
  }
  // Dati Convenzione
  public addDatiConvenzione(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiConvenzione;
    //if(list?.filter(l => l.IdDocumento == "" || l.CodiceCIG == "" || l.CodiceCUP == "" || l.CodiceCommessaConvenzione == "" || l.Data == "" || l.NumItem == "").length == 0){
      list!.push({RiferimentoNumeroLinea: "", IdDocumento:"", Data: "", NumItem: "", CodiceCommessaConvenzione: "", CodiceCUP: "", CodiceCIG: ""});
    //}
  }
  public deletedatiConvenzione(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiConvenzione;
    list?.splice(index, 1);
  }
  // Dati Ricezione
  public addDatiRicezione(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiRicezione;
    //if(list?.filter(l => l.IdDocumento == "" || l.CodiceCIG == "" || l.CodiceCUP == "" || l.CodiceCommessaConvenzione == "" || l.Data == "" || l.NumItem == "").length == 0){
      list!.push({RiferimentoNumeroLinea: "", IdDocumento:"", Data: "", NumItem: "", CodiceCommessaConvenzione: "", CodiceCUP: "", CodiceCIG: ""});
    //}
  }
  public deletedatiRicezione(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiRicezione;
    list?.splice(index, 1);
  }
  // Dati Fatture Collegate
  public addDatiFattureCollegate(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate;
    //if(list?.filter(l => l.IdDocumento == "" || l.CodiceCIG == "" || l.CodiceCUP == "" || l.CodiceCommessaConvenzione == "" || l.Data == "" || l.NumItem == "").length == 0){
      list!.push({RiferimentoNumeroLinea: "", IdDocumento:"", Data: "", NumItem: "", CodiceCommessaConvenzione: "", CodiceCUP: "", CodiceCIG: ""});
    //}
  }
  public deletedatiFattureCollegate(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate;
    list?.splice(index, 1);
  }
  // Dati SAL
  public addDatiSAL(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiSAL;
    //if(list?.filter(l => l.RiferimentoFase == '').length == 0){
      list!.push({RiferimentoFase: ""});
    //}
  }
  public deletedatiSAL(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiSAL;
    list?.splice(index, 1);
  }
  // Dati DDT
  public addDatiDDT(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiDDT;
    //if(list?.filter(l => l.NumeroDDT == '' || l.DataDDT == '').length == 0){
      list!.push({NumeroDDT: '', DataDDT: '', RiferimentoNumeroLinea: ''});
    //}
  }


  public deletedatiDDT(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiDDT;
    list?.splice(index, 1);
  }
  /// Fattura Principale


  public notifyChange(){
    this.modelChange.emit(this.model);
  }
}
